import { createAsyncThunk } from "@reduxjs/toolkit"

import { DashboardEmbedType } from "@common-shared/config/metabase.config.ts"
import { ITokenResponseData } from "@common-shared/types/responseData/commonResponseData.types.ts"

import { DashboardService } from "../../services/dashboard.service.ts"
import type { IThunkActionWithPracticeData } from "../../types/general.types.ts"
import {
    runtimeStartLoading,
    runtimeStopLoading,
} from "../slices/runtime.slice"

/**
 * Get Dashboard embed token
 */
export const getDashboardEmbedToken = createAsyncThunk<
    ITokenResponseData | null,
    IThunkActionWithPracticeData<{
        embedType: DashboardEmbedType
        embedId: number
    }>
>("getDashboardEmbedTokenPrefix", async (action, { dispatch }) => {
    dispatch(runtimeStartLoading("getDashboardEmbedTokenLoading"))

    let result: ITokenResponseData | null = null

    try {
        result = await DashboardService.getEmbedToken(
            action.practice,
            action.payload.embedType,
            action.payload.embedId,
        )

        if (result) {
            action.onSuccess?.(result)
        } else {
            action.onError?.(result)
        }

        return result
    } catch (e) {
        action.onError?.(null)

        return null
    } finally {
        dispatch(runtimeStopLoading("getDashboardEmbedTokenLoading"))
    }
})
